import axiosInstance from "../interceptor/interceptor";
import loanDocumentsDictionary from "../dictionary/loanDocumentsDictionary";

const loanDocumentsServices = {
  getLoanDocuments: (applicationId: string) =>
    axiosInstance.post(loanDocumentsDictionary.getLoanDocuments(), {
      applicationId,
    }),
};
export default loanDocumentsServices;
